import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import cx from 'classnames';
import i18n from 'i18next';
import ModalDialog from '../ui/modal-dialog';
var t = i18n.getFixedT(null, 'setting-service');
var gt = i18n.getFixedT(null, 'app');
var ServiceMonitorDialog = /*#__PURE__*/React.memo(function (props) {
  var onClose = props.onClose,
      data = props.data,
      id = props.id;
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  var renderContent = function renderContent() {
    return _.map(data.entries, function (el, index) {
      var type = index;
      var disk = '';

      if (index.indexOf('Disk Storage') >= 0) {
        var typeAry = type.split(' ');
        type = "".concat(typeAry[0], " ").concat(typeAry[1]);
        disk = typeAry[2];
      }

      switch (type) {
        case 'allocatedMemory':
          return /*#__PURE__*/React.createElement(AllocatedMemory, {
            data: el
          });

        case 'freeDiskSpace':
          return /*#__PURE__*/React.createElement(FreeDiskSpace, {
            data: el
          });

        case 'SQL Server HealthCheck':
          return /*#__PURE__*/React.createElement(SqlServerHealthCheck, {
            data: el
          });

        case 'Disk Storage':
          return /*#__PURE__*/React.createElement(DiskStorage, {
            data: el,
            disk: disk
          });

        case 'Allocated Memory HealthCheck':
          return /*#__PURE__*/React.createElement(AllocatedMemoryHealthCheck, {
            data: el
          });

        case 'TIPC Traffic Model Trainer':
          return /*#__PURE__*/React.createElement(TipcTrafficModelTrainer, {
            data: el
          });

        case 'sqlConnection':
          return /*#__PURE__*/React.createElement(SqlConnection, {
            data: el
          });

        case 'collectiorConnection':
          return /*#__PURE__*/React.createElement(CollectorConnection, {
            data: el
          });

        case 'Elasticsearch Connection HealthCheck':
          return /*#__PURE__*/React.createElement(ElasticsearchConnectionHealthCheck, {
            data: el
          });

        default:
          return null;
      }
    });
  };

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: data.title,
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, renderContent());
});
ServiceMonitorDialog.defaultProps = {
  id: 'g-service-monitor-dialog'
};
ServiceMonitorDialog.propTypes = {
  id: PropTypes.string
};
export default ServiceMonitorDialog; // calculate disk capacity

var calDiskCapacity = function calDiskCapacity(val) {
  // the default unit of val is KB
  var gb = 1024 * 1024,
      mb = 1024;
  if (val > gb) return _.round(Number(val) / gb, 2) + 'GB';else if (val > mb) return _.round(Number(val) / mb, 2) + 'MB';
  return val + 'KB';
};

var calDiskCapacityForByte = function calDiskCapacityForByte(val) {
  // the default unit of val is Bytes
  var gb = 1024 * 1024 * 1024,
      mb = 1024 * 1024,
      kb = 1024;
  if (val > gb) return _.round(Number(val) / gb, 2) + 'GB';else if (val > mb) return _.round(Number(val) / mb, 2) + 'MB';else if (val > kb) return _.round(Number(val) / mb, 2) + 'KB';
  return val + 'Bytes';
};

var AllocatedMemory = function AllocatedMemory(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-allocatedMemory')), /*#__PURE__*/React.createElement("div", {
    className: "content",
    title: data.description
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase())));
};

var FreeDiskSpace = function FreeDiskSpace(_ref2) {
  var data = _ref2.data;
  var d = data.data && !_.isEmpty(data.data) ? data.data : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-freeDiskSpace')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item",
    title: data.description
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase())), !isNaN(d.totalFreeDiskSpace) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-totalFreeDiskSpace'), ": ", calDiskCapacityForByte(d.totalFreeDiskSpace)), !isNaN(d.dailyDiskSpaceUsage) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-dailyDiskSpaceUsage'), ": ", calDiskCapacityForByte(d.dailyDiskSpaceUsage)), !isNaN(d.remainDiskSpaceDays) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-remainDiskSpaceDays'), ": ", d.remainDiskSpaceDays + t('lbl-day'))));
};

var SqlServerHealthCheck = function SqlServerHealthCheck(_ref3) {
  var data = _ref3.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-SQL-server-healthCheck')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase()))));
};

var DiskStorage = function DiskStorage(_ref4) {
  var data = _ref4.data,
      disk = _ref4.disk;
  var d = data.data && !_.isEmpty(data.data) ? data.data : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-disk-storage', {
    disk: disk
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase())), !isNaN(d.totalCapcity) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-totalCapcity'), ": ", calDiskCapacity(d.totalCapcity)), !isNaN(d.usablePartitionSpace) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-usablePartitionSpace'), ": ", calDiskCapacity(d.usablePartitionSpace)), !isNaN(d.usedPartitionSpace) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-usedPartitionSpace'), ": ", calDiskCapacity(d.usedPartitionSpace)), !isNaN(d.systemPartitionUsage) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-systemPartitionUsage'), ": ", _.round(d.systemPartitionUsage, 2), "%")));
};

var AllocatedMemoryHealthCheck = function AllocatedMemoryHealthCheck(_ref5) {
  var data = _ref5.data;
  var d = data.data && !_.isEmpty(data.data) ? data.data : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-allocated-memory-healthCheck')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item",
    title: data.description
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase())), !isNaN(d.totalPhysicalMemorySize) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-totalPhysicalMemorySize'), ": ", calDiskCapacity(d.totalPhysicalMemorySize)), !isNaN(d.freePhysicalMemorySize) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-freePhysicalMemorySize'), ": ", calDiskCapacity(d.freePhysicalMemorySize)), !isNaN(d.physicalMemoryUsage) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-physicalMemoryUsage'), ": ", _.round(d.physicalMemoryUsage, 2), "%"), !isNaN(d.totalSwapSpaceSize) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-totalSwapSpaceSize'), ": ", calDiskCapacity(d.totalSwapSpaceSize)), !isNaN(d.freeSwapSpaceSize) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-freeSwapSpaceSize'), ": ", calDiskCapacity(d.freeSwapSpaceSize)), !isNaN(d.swapSpaceUsage) && /*#__PURE__*/React.createElement("p", {
    className: "item"
  }, t('dlg-swapSpaceUsage'), ": ", _.round(d.swapSpaceUsage, 2), "%")));
};

var TipcTrafficModelTrainer = function TipcTrafficModelTrainer(_ref6) {
  var data = _ref6.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-tipc-traffic-model-trainer')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase()))));
};

var SqlConnection = function SqlConnection(_ref7) {
  var data = _ref7.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-sql-connection')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase()))));
};

var CollectorConnection = function CollectorConnection(_ref8) {
  var data = _ref8.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-collector-connection')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase()))));
};

var ElasticsearchConnectionHealthCheck = function ElasticsearchConnectionHealthCheck(_ref9) {
  var data = _ref9.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('dlg-elasticsearch-connection-health-check')), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle status', data.status.toUpperCase())
  }), t('lbl-' + data.status.toUpperCase()))));
};